import {
    Collapsible, Grid, GridProps, Heading,
    Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { LuChevronDown } from 'react-icons/lu';

export interface ICatalogGroupItem {
    key: string,
    value: any
    title: string
}

export interface ICatalogGroup {
    key: string,
    value: any,
    title: string,
    single? : boolean
    items: ICatalogGroupItem[]
}

export interface ICatalogSelectedValue {
    [key: string]: any
}

type CatalogSectionProps = {
    value: ICatalogSelectedValue
    handleChange: (v: ICatalogSelectedValue) => void
    groups: ICatalogGroup[]
} & GridProps & React.RefAttributes<HTMLDivElement>

type CatalogSectionGroupProps = {
    value: ICatalogSelectedValue
    handleChange: (v: ICatalogSelectedValue) => void
    group: ICatalogGroup
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CatalogSectionGroup: React.FC<CatalogSectionGroupProps> = ({
    value,
    handleChange,
    group,
}) => {
    const [open, setOpen] = useState(true);

    return (
        <Collapsible.Root
            defaultOpen
            onOpenChange={() => setOpen(!open)}
        >
            <Grid gap="0.5rem">
                <Collapsible.Trigger cursor="pointer">
                    <Grid templateColumns="auto 1fr" gap="1rem" width="fit-content">
                        <Grid
                            margin="auto 0"
                            transform={open ? 'rotate(180deg)' : undefined}
                            transition="0.5s"
                        >
                            <LuChevronDown size="1.25rem" />
                        </Grid>
                        <Text fontSize="1.25rem" fontWeight="bold">
                            {group.title}
                        </Text>
                    </Grid>
                </Collapsible.Trigger>
                <Collapsible.Content>
                    <Grid>
                        {group.items.map(({ key: itemKey, title: itemTitle }) => (
                            <Grid
                                key={itemKey}
                                border={value[group.key] === itemKey ? '3px solid #E74C3C' : '3px solid transparent'}
                                padding="0.5rem 1rem"
                                onClick={() => handleChange({
                                    ...value,
                                    [group.key]: itemKey,
                                })}
                                cursor="pointer"
                                fontWeight="bold"
                            >
                                {itemTitle}
                            </Grid>
                        ))}
                    </Grid>
                </Collapsible.Content>
            </Grid>
        </Collapsible.Root>
    );
};

export const CatalogSection: React.FC<CatalogSectionProps> = ({
    value,
    handleChange,
    groups,
    ...props
}) => (
    <Grid gap="1rem" {...props}>
        <Grid gap="1rem">
            <Grid templateColumns="1fr auto" gap="1rem">
                <Heading fontSize="2rem" fontWeight={900}>
                    Каталог
                </Heading>
                <Grid
                    margin="auto 0"
                >
                    {Object.keys(value).length > 0 ? (
                        <Text
                            onClick={() => handleChange({
                                filter: 'all',
                            })}
                            cursor="pointer"
                            fontWeight="bold"
                            color="#E74C3C"
                            zIndex={20}
                            _hover={{
                                color: 'rgba(231, 77, 60, 0.7)',
                            }}
                        >
                            Очистить
                        </Text>
                    ) : undefined}
                </Grid>
            </Grid>
            <Grid
                gap="1rem"
            >
                {groups.map((group) => (
                    group.single ? (
                        <Grid
                            key={group.key}
                            border={value[group.key] === group.value ? '3px solid #E74C3C' : '3px solid transparent'}
                            padding="0.5rem 1rem"
                            onClick={() => handleChange({
                                ...value,
                                [group.key]: group.value,
                            })}
                            cursor="pointer"
                            fontWeight="bold"
                        >
                            <Text fontSize="1.25rem" fontWeight="bold">
                                {group.title}
                            </Text>
                        </Grid>
                    ) : (
                        <CatalogSectionGroup
                            value={value}
                            group={group}
                            handleChange={handleChange}
                        />
                    )
                ))}
            </Grid>
        </Grid>
    </Grid>
);
